import React, { useState, useContext, createContext, useEffect } from 'react';
import styles from './AdminPortal.module.css';
import ConnectWalletHeader from "../header/ConnectWalletHeader";
import ReserveRobotTable from "./ReserveRobotTable";
import UsersTable from "./UserTable";
import AdminWhitelistTable from "./AdminWhitelistTable";
import { PRISMAX_BACKEND_URL } from "../../configs/config";
import PurchaseRecordsTable from "./PurchaseRecordsTable";

// Create a context for the admin portal
const AdminPortalContext = createContext();

// Fetch admin whitelist function
const fetchAdminWhitelist = async (signedAdminSignature) => {
  try {

    const response = await fetch(`${PRISMAX_BACKEND_URL}/api/get-admin-whitelist`);
    if (!response.ok) {
      throw new Error('Failed to fetch admin whitelist');
    }
    const data = await response.json();
    if (data.success && data.data) {
      return data.data.map(admin => admin.wallet_address);
    } else {
      throw new Error('Invalid data format');
    }
  } catch (err) {
    console.error('Error fetching admin whitelist:', err);
    return [];
  }
};

// Main Admin Portal Component
const AdminPortal = () => {
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const [walletAddress, setWalletAddress] = useState(null);
  const [adminLogin, setAdminLogin] = useState(false);
  const [adminWhitelist, setAdminWhitelist] = useState([]);
  const[adminAccessToken,setAdminAccessToken] =useState('')
  useEffect(() => {
    // Load admin whitelist when component mounts
    const loadAdminWhitelist = async () => {
      const whitelist = await fetchAdminWhitelist();
      setAdminWhitelist(whitelist);
    };
    loadAdminWhitelist();
  }, []);

  return (
    <AdminPortalContext.Provider value={{ isWalletConnected }}>
      <div className={styles.adminPortal}>
        <ConnectWalletHeader
          onWalletConnected={(publicKey) => {
            setWalletAddress(publicKey);
          }}
          showPanel={showPanel}
          setShowPanel={setShowPanel}
          requireSignature={true}
          adminWhitelist={adminWhitelist}
          setAdminLogin={setAdminLogin}
          setAdminAccessToken={setAdminAccessToken}
        />

        {adminLogin ? (
          <div className={styles.mainContent}>
            <UsersTable />
            <ReserveRobotTable />
            <AdminWhitelistTable/>
            <PurchaseRecordsTable/>
          </div>
        ) : (
          <div className={styles.connectPrompt}>
            <h2>Welcome to Admin Portal</h2>
            <p>Please connect your wallet to access the admin features.</p>
          </div>
        )}
      </div>
    </AdminPortalContext.Provider>
  );
};

export default AdminPortal;